import Level from "./Level";
import LevelItem from "./LevelItem";
import LevelSide from "./LevelSide";

Level.Side = LevelSide;
Level.Item = LevelItem;

export { Level };
